export default "__VITE_ASSET__Cz211dc7__"